import React from "react";
import { Box, Chip, Grid, Paper, Stack } from "@mui/material";
import styled from "styled-components";

const ItemTitle = styled.text`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const SkillTree = ({ profileData }) => {
    const [skills, setSkills] = React.useState([]);
    const [specs, setSpecs] = React.useState([]);

    const getSelectedSkillsAndSpecializations = () => {
        const userSkills = profileData.skills;
        let tempSpecs = [];
        let tempSkills = [];
        userSkills.forEach((skill) => {
            const selectedSpecs = skill.specializations.filter((spec) => spec.selected);
            if (selectedSpecs.length > 0) {
                tempSpecs = [...tempSpecs, ...selectedSpecs];
                tempSkills = [...tempSkills, skill];
            }
        });
        setSkills(tempSkills);
        setSpecs(tempSpecs);
    };

    React.useEffect(() => {
        getSelectedSkillsAndSpecializations();
    }, [profileData.skills]);

    return (
        <Paper style={{ maxWidth: "450px" }}>
            <Box p={4}>
                <Grid container direction="column" spacing={3}>
                    <Grid item>
                        <Stack direction="column" spacing={1}>
                            <ItemTitle>Skills</ItemTitle>
                            <Stack direction="row" spacing={1}>
                                {skills.length === 0 && <Chip label="N/A" variant="outlined" />}
                                {skills.map((skill) => (
                                    <Chip label={skill.title} variant="outlined" />
                                ))}
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item>
                        <Stack direction="column" spacing={1}>
                            <ItemTitle>Tech</ItemTitle>
                            <Stack direction="row" spacing={1}>
                                {specs.length === 0 && <Chip label="N/A" variant="outlined" />}
                                {specs.map((spec) => (
                                    <Chip label={spec.title} variant="outlined" />
                                ))}
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default SkillTree;
